<body class="body-form-signin login-bg"
  [style]="whitelabel ? 'background-image: url(' + whitelabelURL + whitelabel + '/login.webp);' : ''">
  
  <main class="form-register">
    <form class="form-shadow p-4" [formGroup]="forgotPasswordForm" autocomplete="off" novalidate
      (ngSubmit)="forgotPassword(forgotPasswordForm.value)">
      <div class="container justify-content-center">
        <div class="row justify-content-center">

          <app-message [service]="messageService"></app-message>

          <div class="text-center">
            <a href="https://cubos.com" target="_blank" *ngIf="!whitelabel || whitelabel == 'cubos'">
              <img class="mb-4" src="assets/images/cubos_connect_logo_4c.svg" alt="CUBOS.Connect" width="272">
            </a>
            <a *ngIf="whitelabel">
              <img class="logo mb-4" [src]="whitelabelURL + whitelabel + '/logo.png'" [alt]="whitelabel">
            </a>

            <div class="col-md-12 col mb-2">
              <h3 class="font-weight-bold ml-md-0 mx-auto text-center" i18n="@@ForgotPasswordHeader">Passwort vergessen?</h3>
              <h4 class="mt-md-2 ml-md-0 ms-2 text-center" i18n="@@ForgotPasswordLabel">
                Kein Problem. Bitte tragen Sie Ihre E-Mail in das Feld ein und fordern Sie ein neues Passwort an.
              </h4>
            </div>
          </div>
        </div>

        <div class="row justify-content-center round">
          <div class="col-lg-10 col-md-12">
            <div class="form-group">
              <div class="col-md-14 col-lg-12 col-12 mt-3 text-left h6">
                <!-- <label id="email_recovery_label" for="email_recovery" i18n="@@EmailRecoveryLabel">Ihre E-Mail-Adresse</label> -->

                <input type="text" id="email" formControlName="email" class="form-control" placeholder="Ihre E-Mail-Adresse" />

                <div class="error">
                  <em *ngIf="validateControl('email') && hasError('email', 'required')" i18n="@@E-MailRequiredError">E-Mail wird benötigt</em>
                </div>
              </div>

              <div class="form-group mt-3">
                <div class="row justify-content-center">
                  <div class="col-md-12 col-lg-10 col-12">
                    <div class="mb-1 text-center">
                      <div class="group">
                        <button [routerLink]="['/auth/login']" id="backtologin" class=" btn btn-yellow mb-2 mb-md-0" i18n="@@BackToLoginButton">Zurück zur Anmeldung</button>
                        <button type="submit" id="newpassword" class="ms-1 btn btn-yellow mb-2 mb-md-0" [disabled]="!forgotPasswordForm.valid" i18n="@@NewPasswordButton">Neues Passwort anfordern</button>
                      </div>
                    </div>
                    <p class="mt-2 mb-3 text-center text-muted"><a href="https://www.cubos.com" target="_blank" style="text-decoration: none; color: #6c757d;">© {{currentYearLong()}} CUBOS Service GmbH</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </main>
  </body>
